const NoComponent = () => null;

export default NoComponent;
